export const states = [
  'São Paulo',
  'Rio de Janeiro',
  'Minas Gerais',
  'Bahia',
  'Paraná',
  'Rio Grande do Sul',
  'Pernambuco',
  'Ceará',
  'Pará',
  'Santa Catarina',
  'Goiás',
  'Maranhão',
  'Amazonas',
  'Espírito Santo',
  'Paraíba',
  'Rio Grande do Norte',
  'Mato Grosso',
  'Alagoas',
  'Piauí',
  'Distrito Federal',
  'Mato Grosso do Sul',
  'Sergipe',
  'Rondônia',
  'Tocantins',
  'Acre',
  'Amapá',
  'Roraima'
];